import { ref } from 'vue';

export function useSetErrors() {
    const formNode = ref('');
    const setBackendErrors = (errors) => {
        formNode.value.setErrors(null, errors);
        setTimeout(() => {
            const formkitOuterElements = document.querySelectorAll(
                '.formkit-outer[data-errors]'
            );
            formkitOuterElements.forEach((element) => {
                for (const key of Object.keys(errors)) {
                    const input = element.querySelector(`[name="${key}"]`);
                    if (input) {
                        input.focus();
                    }
                    break;
                }
            });
        }, 100);
    };

    return {
        formNode,
        setBackendErrors,
    };
}
